import Repository from '../axios'
import {defaultPagination} from "@/constants/config";

export default {
  get(tenant_id, pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`/landlord/tenant/${tenant_id}/suppliers?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getSupplierDetails(tenant_id, supplier_id) {
    return Repository.get(`/landlord/tenant/${tenant_id}/suppliers/${supplier_id}`)
  },
  getListOfSupplierManufacturingSites(tenant_id, supplier_id, pageNumber = 1, filterQuery, pagination = defaultPagination, sort = '') {
    return Repository.get(`/landlord/tenant/${tenant_id}/suppliers/${supplier_id}/sites?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getListOfSupplierRawMaterial(tenant_id, supplier_id, pageNumber = 1, filterQuery, pagination = defaultPagination, sort = '') {
    return Repository.get(`/landlord/tenant/${tenant_id}/suppliers/${supplier_id}/raw-materials?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
}
